import { render } from "./delProduct.vue?vue&type=template&id=23461111"
import script from "./delProduct.vue?vue&type=script&lang=js"
export * from "./delProduct.vue?vue&type=script&lang=js"

import exportComponent from "G:\\Project\\vue_demo\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__